const colors = {
  podcastDarkIndigo: '#1C1463',
  podcastDarkIndigo700: '#2D2290',
  podcastDarkIndigo500: '#3C2EBB',
  podcastVividBlue: '#2945FF',
  podcastVividBlue700: '#001DDE',
  podcastVividBlue800: '#0017AF',
  podcastBlue: '#00B5FF',
  podcastBlue600: '#12A6E2',
  podcastBlue700: '#007DB7',
  podcastLightBlue: '#BFD6FF',
  podcastLightBlue100: '#E5F8FF',
  podcastLightBlue200: '#E3EDFF',
  podcastLightBlue300: '#B0CAF8',
  podcastPurple: '#7B2BEE',
  podcastPurple100: '#F2EAFD',
  podcastPurple200: '#E6D4FB',
  podcastPurple500: '#883DF4',
  podcastPurple800: '#6A1FD6',
  podcastPink: '#FF82EB',
  podcastPink700: '#EE3CD1',
  podcastPink600: '#F960E0',
  podcastRed: '#E64643',
  podcastRed100: '#FDECEC',
  podcastRed400: '#EF5B59',
  podcastRed600: '#D4322F',
  podcastAquaGreen: '#00D4BD',
  podcastAquaGreen700: '#15C3B1',
  podcastAquaGreen300: '#0CEAD2',
  podcastPaleTurquoise: '#8AFFDB',
  podcastPaleTurquoise200: '#D6FFF2',
  podcastPaleTurquoise400: '#79F5CF',
  podcastYellow: '#FFED2B',
  podcastYellow100: '#FFFCDF',
  podcastYellow800: '#79452E',
  podcastShade800: '#1B2432',
  podcastShade700: '#303B4B',
  podcastShade600: '#455265',
  podcastShade500: '#5A687C',
  podcastShade400: '#8F9AAA',
  podcastShade300: '#CCD2DC',
  podcastShade200: '#E6EBEF',
  podcastShade100: '#F4F6F8',
  podcastOrange300: '#FFB870',
  podcastOrange: '#FF9D42',
  podcastOrange500: '#E77F1D',
  trustpilotGreen: '#00B77F',
  white: '#ffffff',
  black: '#000000',
};

export default colors;

export const transcriptSpeakerColors = [
  '#775cef',
  '#73c5c9',
  '#86cb64',
  '#fcb353',
  '#ed4745',
  '#be90d4',
  '#486ce8',
  '#57d99a',
  '#fac73c',
  '#ff7c47',
  '#ff71a4',
];

export const alituBrandPurple = {
  solid: { value: colors.podcastPurple },
  contrastText: { value: colors.white },
  fg: { value: colors.podcastShade800 },
  muted: { value: colors.podcastPurple100 },
  subtle: { value: colors.podcastPurple500 },
  emphasized: { value: colors.podcastPurple800 },
  focusRing: { value: colors.podcastPurple500 },
};
